import { Component, OnInit, OnChanges, Input, SimpleChange } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RxComponent } from 'app/core/components/common/rx.component';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';
import { EmployeeService } from '../employee.service';
import { EmployeeDetails } from './employee-details.model';
import { IfStmt } from '@angular/compiler/src/output/output_ast';

declare var $: any;
@Component({
  selector: 'itpx-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.css']
})
export class EmployeeFormComponent extends RxComponent implements OnInit {

    private id: string;
    @Input()
    private type: string;
    @Input()
    private details: EmployeeDetails = new EmployeeDetails();
    private departments: any = [];
    private roleDict: any = [];
    private domains: any = [];
    private currentDepartment: string;
    private flatRoles: any[];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private service: EmployeeService
    ) {
        super();
    }

    ngOnInit() {
        if(this.type === 'update') {
            $('[name="email"]').prop('disabled', true);
            this.route.params.subscribe(params => {
                this.id = params['id'];
                this.service.getEmployeeDetails(this.id)
                    .subscribe(
                        body => {
                            if(body.data && !body.data.active)
                                body.data.active = false;
                            if(body.data && body.data.department && body.data.department.id)
                                this.currentDepartment = body.data.department.id;

                            let details = <any>body['data'];
                            let accountGroups = details.roles ? details.roles : [];
                            this.flatRoles = [];
                            accountGroups.forEach(element => {
                                this.flatRoles.push(element.id);
                            });
                            this.details = details;
                            this.details.activeInitial = this.details.active;
                        }
                    );
            });
        }
        this.service.getDepartments()
            .subscribe(
                body => this.departments = body.data
            );
        this.service.getRoles()
            .subscribe(
                body => this.roleDict = body.data,
            );
        this.service.getDomains({'@b2b': true})
            .subscribe(
                body => this.domains = body.data,
            );
    }

    ngAfterViewChecked() {

        $('input[type=radio]:checked').each(function() {
            if($(this).parent().hasClass('btn-default')) {
                $(this).parent().removeClass('btn-default');
                $(this).parent().addClass('btn-success');
                $(this).parent().siblings().removeClass('btn-success');
                $(this).parent().siblings().addClass('btn-default');
            }
        });

        $('input[type=radio]:disabled').each(function() {
            $(this).parent().addClass('disabled');
            $(this).parent().siblings().addClass('disabled');
        })

    }

    private onPhoneNumbersChange(phoneNumbers: any[]) {
        this.details.phoneNumbers = phoneNumbers;
    }

    private save() {
        if(this.flatRoles && this.flatRoles.length) {
            let result = [];
            this.flatRoles.forEach(id => {
                result.push({id: id});
            });
            this.details.roles = result;
        }

        if(this.currentDepartment) {
            this.details.department = {
                id: this.currentDepartment
            }
        } else {
            this.details.department = this.currentDepartment;
        }

        let call;
        if(this.type === 'create') {
            call = this.service.add(this.details);
        } else {
            if(this.details.active != this.details.activeInitial){
                if(this.details.active == true){
                    this.service.activate(this.details)
                    .subscribe();
                }else{
                    this.service.deactivate(this.details)
                    .subscribe();
                }
                this.details.activeInitial = this.details.active;
            }
            call = this.service.edit(this.details);

        }
        call.subscribe(
                body => {
                    this.notificationService.success('Successfully saved the employee', 'Success');
                    this.router.navigate(['/agora/account-data/employees/']);
                }
            );
    }
    private onSwitchToggleBtn(e:any) {
        $(e.target).parent().toggleClass('btn-default');
        $(e.target).parent().toggleClass('btn-success');

        $(e.target).parent().siblings().toggleClass('btn-success');
        $(e.target).parent().siblings().toggleClass('btn-default');

        console.log("active changed to",this.details.active);

        if(this.details.active == true){
            this.service.activate(this.details)
            .subscribe(
                body => {
                    this.notificationService.success('Employee successfully activated', 'Success');
                }
            );
        }
        else{
            this.service.deactivate(this.details)
            .subscribe(
                body => {
                    this.notificationService.success('Employee successfully deactivated', 'Success');
                }
            );
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/form/employee-form.component.ts